import { render, staticRenderFns } from "./UsuariosCreate.vue?vue&type=template&id=70869861&"
import script from "./UsuariosCreate.vue?vue&type=script&lang=js&"
export * from "./UsuariosCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports